//#region IMPORT
import SubOrderDetailHeader from "./SubOrderDetailHeader";
import SubOrderDetailList from "./SubOrderDetailList";
import { SubOrder } from "../../models/suborder";
import { Fragment } from "react";
import { Order } from "../../models/order";
//#endregion

interface Props {
  order: Order | null;
  subOrder: SubOrder | null;
}

export default function SubOrderDetail({ order, subOrder }: Props) {
  //#region RENDER
  return order && subOrder ? (
    <Fragment>
      <SubOrderDetailHeader order={order} subOrder={subOrder} />
      <SubOrderDetailList order={order} subOrderId={subOrder.id} />
    </Fragment>
  ) : (
    <p>loading</p>
  );
  //#endregion
}
